"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Bonuses = {
    wordBoundary: 30,
    consecutiveLetters: 15,
    separation: -1,
    distanceFromFilename: -10,
    repeatedSelection: 10,
    recentSelection: 10
};
var Match = /** @class */ (function () {
    function Match(value, key, searchRegex) {
        this.matched = false;
        this.matchList = [];
        this.parts = [];
        this.value = value;
        this.name = key(value);
        this.regex = searchRegex;
        if (!this.name) {
            this.matched = false;
            return;
        }
        var matchList = this.name.toLowerCase().match(searchRegex);
        if (!matchList) {
            this.matched = false;
            return;
        }
        this.matched = true;
        this.matchList = matchList.slice(1);
        this.parts = this.getParts();
    }
    Match.search = function (search, list, key) {
        search = search.toLowerCase();
        var regex = new RegExp("(.*?)(" + search.split("").map(function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join(")(.*?)(") + ")(.*)");
        var matches = Array.from(list).map(function (item) { return new Match(item, key, regex); });
        matches = matches.filter(function (m) { return m.matched; });
        matches.sort(function (a, b) { return b.score() - a.score(); });
        return matches.map(function (m) { return m.value; });
    };
    Match.prototype.totalLength = function () {
        return this.parts[this.parts.length - 1].index - this.parts[0].index + 1;
    };
    Match.prototype.matchedLength = function () {
        return (this.matchList.length - 1) / 2;
    };
    Match.prototype.getParts = function () {
        var _this = this;
        var ind = -1;
        var ret = (function () {
            var result = [];
            for (var i = 0, end = _this.matchedLength(), asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
                ind += _this.matchList[i * 2].length + _this.matchList[i * 2 + 1].length;
                result.push({
                    match: _this.matchList[i * 2 + 1],
                    index: ind
                });
            }
            return result;
        })();
        return ret;
    };
    Match.prototype.wordBoundaryBonus = function () {
        var bonus = 0;
        for (var _i = 0, _a = Array.from(this.parts); _i < _a.length; _i++) {
            var part = _a[_i];
            if (part.index === 0 ||
                this.name[part.index - 1] === "-" ||
                this.name[part.index - 1] === " ") {
                bonus += Bonuses.wordBoundary;
            }
        }
        return bonus;
    };
    Match.prototype.separationBonus = function () {
        return (this.totalLength() - this.matchedLength()) * Bonuses.separation;
    };
    Match.prototype.consecutiveLettersBonus = function () {
        var bonus = 0;
        for (var i = 1, end = this.parts.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
            if (this.parts[i].index - this.parts[i - 1].index === 1) {
                bonus += Bonuses.consecutiveLetters;
            }
        }
        return bonus;
    };
    Match.prototype.score = function () {
        return (this.separationBonus() +
            this.wordBoundaryBonus() +
            this.consecutiveLettersBonus());
    };
    return Match;
}());
function filterActions(actions, search) {
    return Match.search(search, actions, function (v) { return v.action.name; });
}
exports.filterActions = filterActions;
//# sourceMappingURL=action-search.js.map